import { ReactElement } from 'react'

import { useHasConnectedBankAccount } from '@features/bankAccounts/hooks/useHasConnectedBankAccount'
import { useBankTransactionsAccess } from '@features/bankTransactions/hooks/useBankTransactionsAccess'
import { useCanConnectToShineBank } from '@features/shineBanking/hooks/useCanConnectToShineBank'

import { ShineBanner } from '../ShineBanner'
import { TransactionsDemoBanner } from '../TransactionsDemoBanner'

interface AccountsBannerProps {
  withBottomMargin?: boolean
  onOpenSandbox: () => void
}

/**
 * Picks which banner the accounts page shows. Bucket-1 organisations get the transactions
 * demo banner — they're the only ones who can reach the real transactions view, and the
 * banner says nothing Shine-specific, so it isn't limited by country or brand. Everyone
 * else keeps the Shine merge banner on its original rules (Shine UI setup, no Shine
 * account connected yet, merge scope), so the two audiences never overlap.
 */
export const AccountsBanner = ({ withBottomMargin, onOpenSandbox }: AccountsBannerProps): ReactElement => {
  const { isTransactionsOnboardingEnabled } = useBankTransactionsAccess()
  const { canConnectToShineBank } = useCanConnectToShineBank()
  const { hasConnectedBankAccount } = useHasConnectedBankAccount()

  return (
    <>
      <TransactionsDemoBanner
        shouldShow={isTransactionsOnboardingEnabled && !hasConnectedBankAccount}
        withBottomMargin={withBottomMargin}
        onOpenSandbox={onOpenSandbox}
      />
      <ShineBanner
        shouldShow={!isTransactionsOnboardingEnabled && canConnectToShineBank}
        withBottomMargin={withBottomMargin}
      />
    </>
  )
}
